<div class="account-limits-container">
  <div class="account-limits-title">
    Transaction Limits
    <button
      class="limits-edit-button"
      [hidden]="!isEditAllowed || permissionDenied"
      [disabled]="false | accessControl | async"
      (click)="onEditClick()"
    >
      <rkt-icon name="edit"></rkt-icon>
    </button>
  </div>

  @if (permissionDenied) {
    <div class="limits-permission-denied">Insufficient permissions to view transaction limits.</div>
  } @else {
    <div class="limits">
      @for (item of transactionLimits; track item.id) {
        <app-transaction-limit-item [limitItem]="item"></app-transaction-limit-item>
      }
    </div>
  }
</div>
